// Deve estar num arquivo separado para evitar imports cíclicos.

import Canterizacao from "./Canterizacao";
import Colheita from "./Colheita";
import MPB from "./MPB";
import Plantio from "./Plantio";
import Pragas from "./Pragas"
import ColheitaMuda from "./ColheitaMuda"
import PreparoSolo from "./PreparoSolo";
import TratosPlanta from "./TratosPlanta";
import TratosSoca from "./TratosSoca";

// Deve estar num arquivo separado para evitar imports cíclicos.
// Estão na ordem que irão aparecer nas listagens e configurações.
const all = [PreparoSolo, Plantio, Pragas, MPB, Canterizacao, TratosPlanta, TratosSoca, Colheita, ColheitaMuda];

/**
 * Todos os tipos de indicador existentes.
 */
export default function getAllTiposIndicador() {
    return all;
}

export function getTiposIndicadorByField(field) {
    for (const TipoClass of all) {
        if (TipoClass.field === field) {
            return TipoClass;
        }
    }
}

